<template>
  <!-- Contenido del listado de noticias -->
  <section class="wmax list-item-home list-noticias">
    <div class="row">
      <div class="col col-4">
        <h2>Noticias</h2>
      </div>
      <div class="col col-8 text-right" style="padding-top: 7px">
        <!--<div class="bnt_orange">VER TODAS</div>-->
      </div>
    </div>
    <div class="row wrap_noticias">
      <div class="col col-12" v-if="loading">Cargando noticias...</div>

      <div v-else v-for="noticia in noticias" :key="noticia.id" class="col col-xs-12 col-3 item-noticia noticia">
        <div class="image-lugar"><img v-bind:src="`https://murciabarroca.es/${noticia.imagen}`" /></div>

        <p
          class="fecha"
          v-text="
            new Date(noticia.fecha).toLocaleDateString('es-ES', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })
          "
        ></p>
        <h2 class="titulo-noticia">{{ noticia.titulo }}</h2>
        <p class="texto-noticia">{{ truncarTexto(noticia.texto) }}</p>
        <router-link :to="{name: 'DetalleNoticia', params: {idnoticia: noticia.id}}">
          <div class="text-right next" style="user-select: none">
            VER NOTICIA COMPLETA
            <img src="@/assets/img/flecha_right.svg" width="30" />
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
  import axios from "axios";

  export default {
    data() {
      return {
        noticias: [],
        loading: true,
      };
    },
    mounted() {
      axios
        .get("https://murciabarroca.es/api/getNoticias/")
        .then((response) => {
          this.noticias = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error("Error al obtener los datos:", error);
        })
        .finally(() => {
          this.loading = false; // Finalmente, se oculta el estado de carga
        });
    },
    methods: {
      truncarTexto(texto) {
        if (texto.length > 100) {
          // Puedes ajustar el número de caracteres aquí
          texto = texto.replace(/<[^>]*>/g, "");
          return texto.slice(0, 100) + "...";
        }
        //return texto.replace(/<[^>]*>/g, "");
      },
    },
  };
</script>
<style scoped>
  /* Estilos específicos del listado de noticias */
</style>
